import { useMyLanguage } from 'app/_hooks'

/**
 * url?locale=<my_language>の形でクエリパラムに付与するための値を作成するhooks
 */
/* @deprecated
 *  request header X-App-Language で送っているので、今後は使わない
 */
export function useAddLocaleParams(): string {
  const language = useMyLanguage()

  return `locale=${language}`
}
